/* eslint-disable no-unused-vars */
import 'react-chat-widget-t/lib/styles.css';
import {
  Widget, toggleWidget, setQuickButtons, renderCustomComponent, addUserMessage, addResponseMessage,
} from 'react-chat-widget-t';
import { PropTypes } from 'prop-types';
import { createStructuredSelector } from 'reselect';
import React, { useEffect } from 'react';
import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import _ from 'lodash';
import useRecorder from '../../useRecorder';

import { uuidv4 } from '../../utils';
import Audio from '../Audio/Audio';
import { sendMessage, sendTextMessage } from './actions';
import { updateDefaultMessageRequest } from '../../services/message/actions';
import { makeSelectMessage, makeSelectLoading, makeSelectDefaultMessageRequest } from '../../services/message/selectors';
import './Webwidget.css';

const DELIGHT_LOGO = 'data:image/svg+xml;base64,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';

const audioComponentCallback = (url) => {
  renderCustomComponent(Audio, {
    audioURL: url,
  });
};

function Webwidget(props) {
  const {
    title, webhook, subtitle, isTest,
  } = props;
  const uuid = uuidv4();

  const setDefaultMessageRequest = () => {
    let lang = navigator.language.substring(0, 2);
    lang = ['en', 'zh'].includes(lang) ? lang : 'en';
    props.updateDefaultMessageRequest({
      message: {
        from: {
          id: uuid,
          username: uuid,
          language_code: lang,
        },
      },
    });
  };

  /**
   * Just for test case now.
   */
  const sendWelcomeMessage = () => {
    if (isTest) {
      addResponseMessage('Welcome 👋 \n\nThis is a test widget. \n\nInput your message here.');
    }
    // else {
    //   props.sendTextMessage('Hello');
    // }
  };

  const getVoiceResponse = async (file) => {
    const fromData = new FormData();
    fromData.append('file', file);

    const data = _.cloneDeep(props.defaultMessageRequest);
    data.message.voice = {
      type: 'wav',
    };
    fromData.append('data', JSON.stringify(data));

    props.sendMessage(fromData);
  };

  const [isRecording, startRecording,
    stopRecording] = useRecorder(audioComponentCallback, getVoiceResponse);

  const handleNewUserMessage = (newMessage) => {
    props.sendTextMessage(newMessage);
  };

  const handleStream = async () => {
    if (isRecording) {
      stopRecording();
    } else {
      startRecording();
    }
  };

  const handleQuickButtonClicked = (buttonValue) => {
    addUserMessage(buttonValue);
    setQuickButtons([]);
    props.sendTextMessage(buttonValue);
  };

  useEffect(() => {
    toggleWidget();
    setDefaultMessageRequest();
    sendWelcomeMessage();
  }, []);

  return (
    <Widget
      fullScreenMode
      toggleWidget
      handleNewUserMessage={handleNewUserMessage}
      handleQuickButtonClicked={handleQuickButtonClicked}
      // profileAvatar={DELIGHT_LOGO}
      title={title}
      subtitle={subtitle}
      showCloseButton={false}
      isRecording={isRecording}
      handleStream={handleStream}
    />
  );
}

const mapStateToProps = createStructuredSelector({
  message: makeSelectMessage(),
  loading: makeSelectLoading(),
  defaultMessageRequest: makeSelectDefaultMessageRequest(),
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    sendMessage,
    sendTextMessage,
    updateDefaultMessageRequest,
  }, dispatch);
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

Webwidget.propTypes = {
  sendMessage: PropTypes.func.isRequired,
  sendTextMessage: PropTypes.func.isRequired,
  updateDefaultMessageRequest: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  webhook: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  isTest: PropTypes.bool.isRequired,
  message: PropTypes.shape({}),
  defaultMessageRequest: PropTypes.shape({
    from: PropTypes.shape({
      id: PropTypes.string,
      username: PropTypes.string,
      language_code: PropTypes.string,
    }),
  }),
};

export default compose(
  withConnect,
)(Webwidget);
